

// Get Settings
export const getStatistiquesStart =()=>({
    type: "GET_STATISTIQUES_START",
});
export const getStatistiquesSuccess =(statistiques)=>({
    type: "GET_STATISTIQUES_SUCCESS",
    payload: statistiques,
});
export const getStatistiquesFailure =(error)=>({
    type: "GET_STATISTIQUES_FAILURE",
    payload: error,
});